// useMediaQuery.js

import { useState, useEffect } from 'react';

const useMediaQuery = (query) => {
  // 1. Initialiser l'état. Lors du premier rendu côté serveur (si SSR), on suppose false.
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    // 2. Vérifier si l'environnement 'window' existe (pour éviter les erreurs SSR)
    if (typeof window !== 'undefined') {
      const media = window.matchMedia(query);
      
      // Définir l'état initial côté client
      setMatches(media.matches);

      // Fonction écouteur pour les changements de taille
      const listener = (event) => setMatches(event.matches);

      // Ajouter et nettoyer l'écouteur
      // Utilisation de .addListener/.removeListener pour la compatibilité
      if (media.addEventListener) {
        media.addEventListener('change', listener);
      } else {
        // Fallback pour les anciens navigateurs
        media.addListener(listener);
      }

      return () => {
        if (media.removeEventListener) {
          media.removeEventListener('change', listener);
        } else {
          media.removeListener(listener);
        }
      };
    }
  }, [query]);

  return matches;
};

export default useMediaQuery;